import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import {
  SectionHeading,
  Subheading as SubheadingBase
} from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import SmartTimelapse from "images/custom/smartTimelapse.svg";
import SmartDaily from "images/custom/smartDaily.svg";
import CloudRecording from "images/custom/cloudRecording.svg";
import { HASH_FEATURES } from "helpers/Constants";

const Container = styled.div`
  ${tw`relative -mx-8 px-8 text-gray-100`}
  ${css`
    background: linear-gradient(89.18deg, #095ec2 5.55%, #0ecbf4 100%);
  `}
`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-20 md:py-24`}
`;
const Subheading = tw(SubheadingBase)`mb-4 text-gray-100`;
const Heading = tw(SectionHeading)`w-full font-bold`;
const Description = tw(
  SectionDescription
)`w-full text-center text-gray-300 text-2xl`;

const VerticalSpacer = tw.div`mt-10 w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-xs`}
`;

const Card = styled.div`
  ${tw`flex flex-col items-center sm:items-start text-center sm:text-left h-full mx-4 px-2 py-8`}
  .imageContainer {
    img {
      ${tw`w-32 h-32`}
    }
  }

  .textContainer {
    ${tw`mt-6`}
  }

  .title {
    ${tw`tracking-wider font-bold text-2xl leading-none`}
  }

  .description {
    ${tw`mt-2 font-normal text-lg text-white leading-snug`}
  }
`;

export default ({
  cards = null,
  heading = "獨家 AI 影像技術",
  subheading = "",
  description = "智慧瀏覽每日紀錄"
}) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const defaultCards = [
    {
      imageSrc: SmartTimelapse,
      title: "智慧縮時",
      description: "智慧影像摘要，10 分鐘一覽全天重要事件。"
    },
    {
      imageSrc: SmartDaily,
      title: "智慧日誌",
      description: "智慧圖像索引，精準回顧影像重要時刻。"
    },
    {
      imageSrc: CloudRecording,
      title: "雲端錄影",
      description: "256-bit SSL 安全加密層級，安心保存隨時回放。"
    }
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container id={HASH_FEATURES}>
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                <p className="description">
                  {card.description ||
                    "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
    </Container>
  );
};
